import React from 'react';
import Paragraph from '../../Paragraph';

export interface InlinePageTextProps {
    paragraph: string;
    fileTypes: string[];
}

export default function InlinePageFileDeliverables({ paragraph, fileTypes }: InlinePageTextProps) {
    return (
        <div className="inline-page-file-deliverables">
            <Paragraph variations={['no-margin']}>{paragraph}</Paragraph>
            <div className="inline-page-file-deliverables__file-types">
                {fileTypes.map((fileType, index) => (
                    <div
                        className="inline-page-file-deliverables__file-types__file-type"
                        key={index}
                    >
                        {fileType}
                    </div>
                ))}
            </div>
        </div>
    );
}

InlinePageFileDeliverables.calculateMaxHeightPercentage = function (): number {
    return 0.25;
};
